import React, { useCallback, useState } from 'react';
import {
  KoTitle,
  KoForm, KoLoader,
  KoButton,
  KoTabs,
  KoModal,
  KoToast,
  KoDescription
} from 'packages';
import KoIcon from '@kwapio/icons';

import BusinessInfoCurd from './curd/business';
import BusinessProfile from './curd/businessprofile';
import PreferencesCrud from './curd/preferences';
import AddressCrud from './curd/address';
import DiscountCrud from './curd/discount';
import TaxCrud from './curd/tax';
import BankCrud from './curd/bank';

import styles from './settings.module.scss';
import { ClientsAPI } from 'pages/customers/customers.service';
import { deepMerge } from 'shared/utils';



function CustomerDetails(props) {
  const { openCustomerModal, settings, setOpenCustomerModal, getByIdSettings, activeTab, setActiveTab } = props;
  const [isLoading, setLoading] = useState(false);
  const [form] = KoForm.useForm();
  const handleFinish = useCallback((values, refresh) => {
    setLoading(true);
    const updatedCObj = deepMerge(settings, values);
    ClientsAPI.createOrUpdateClient(updatedCObj, settings?.customerId).then(
      (data) => {
        setLoading(false);
        if (refresh !== 'refresh') {
          KoToast.success('Account settings saved!');
        }
        getByIdSettings(settings?.customerId);
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const onValuesChange = (changedValues, refresh) => {
    const updatedCObj = deepMerge(settings, changedValues);
    if (refresh === 'refresh') {
      handleFinish(updatedCObj, refresh);
    }
  };

  const panelStyle = {
    marginBottom: 2,
    background: '#fff',
    border: 'none',
    borderRadius: 1
  };

  const HEADER_OPTIONS = [{
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="BusinessFilled" height={12} width={12} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Business Information" />
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <BusinessInfoCurd onValuesChange={onValuesChange} settings={settings} form={form} />
      </KoForm>
    </>
    ,
    key: 1,
    style: panelStyle
  },
  {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="BusinessProfileFilled" height={15} width={15} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Business Profile" />
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <BusinessProfile settings={settings} form={form} />
      </KoForm>
    </>,
    key: 2,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="PreferencesFilled" height={12} width={12} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="General Preferences" />
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <PreferencesCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 3,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="LocationFilled" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Address Information" />
        {/* <KoDescription className={styles.description} text="Details about organization  location" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <AddressCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 4,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="BankFilled" height={14} width={14} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Bank Details" />
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <BankCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 5,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="TaxFilled" height={12} width={12} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Tax Details" />
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <TaxCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 6,
    fields: 2,
    outof: 5,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="DiscountFilled" height={16} width={16} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Discount Details" />
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <DiscountCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 7,
    style: panelStyle
  }];
  console.log('HEADER_OPTIONS', activeTab);
  return (
    <KoModal
      title={`${settings?.companyName?.toUpperCase() || 'Create Customer'}`}
      centered
      open={openCustomerModal}
      handleOk={() => { setOpenCustomerModal(false); }}
      onClose={() => { setOpenCustomerModal(false); }}
      width={'80vw'}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setOpenCustomerModal(false)} />,
        <KoButton key='reset' loading={isLoading} type='primary' label='Update' onClick={() => form.submit()} />,
        <KoButton key='update' loading={isLoading} type='primary' label='Update and Close' onClick={() => {form.submit(); setOpenCustomerModal(false);}} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={`${styles.layout} profileSection`}>
        {isLoading && <KoLoader />}
        <div className={styles.wrapper}>
          <div className={styles.breadcrumb}>
            <KoTitle className={styles.title} strong={true} level={5} text={`The settings for ${settings?.companyName}. have been configured.`} />
          </div>
          <KoDescription className={styles.descriptionTitle} text={`All of the preferences below are directly associated
          with the current business (${settings?.companyName})
          you are currently using. Changes on this page will only affect the current business.`} />
          <KoTabs options={HEADER_OPTIONS} activeKey={activeTab} onChange={setActiveTab} />
        </div>
      </div>
    </KoModal>
  );
}

export default CustomerDetails;